var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{class:_vm.baseClass},[_c('AppHeaderUser',{class:`${_vm.baseClass}__user`,attrs:{"collapsed":_vm.collapsed}}),_c('EpbText',{class:[
      `${_vm.baseClass}__version`,
      {
        [`${_vm.baseClass}__version--collapsed`]: _vm.collapsed,
      },
    ],attrs:{"tag":"p","type":"small","show-ellipsis":"","color":_vm.ColorEnum.NEUTRAL_75}},[_vm._v("\n    v"+_vm._s(_vm.$epb.version)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }